import { createAsyncThunk } from "@reduxjs/toolkit";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";

export const getGenreList = createAsyncThunk(
  "genre/list",
  async ({ pageCount, limit, search }) => {
    const response = await Client(
      API_METHOD.GET,
      url.genres +
        `?page=${pageCount}&limit=${limit}&deleted_at=1&q=${
          !search ? "" : search
        }`
    );
  
    return response.data;
  }
);

export const addGenre = createAsyncThunk(
  "genre/add",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Client(API_METHOD.POST, url.genres, data);
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

//fetch

export const editGenre = createAsyncThunk(
  "genre/edit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await Client(
        API_METHOD.PUT,
        url.genres + `/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error) {
        return rejectWithValue(error);
      } else {
        return rejectWithValue("Something went wrong");
      }
    }
  }
);

export const getGenreCount = async () =>{
  const response = await Client(API_METHOD.GET, url.genres)
  return response.data?.data?.item?.total_count;
}

export const getGenre = createAsyncThunk("genre/one", async (id) => {
  const response = await Client(API_METHOD.GET, url.genres + `/${id}`);
  return response.data;
});

